export default {
    mapGeofenceSettings_geofences: "Geocercas",
    mapGeofenceSettings_units: "Unidades",
    mapGeofenceSettings_groups: "Grupos"
};